import VideoThumbnail from 'react-video-thumbnail';

function VideoThumbnails(props: any) {
    return (<VideoThumbnail
        videoUrl={props.videoUrl}
        width={props.width ?? 1500}
        height={props.height ??844}
        snapshotAtTime={0.01}
    />);
}

export default VideoThumbnails;